import { request } from "../http";

export default {
    // 获取商学院banner
    getCourseBannerList(params) {
        return request('post', '/sd_smi/api/v1/App_Course/getCourseBannerList', params, 'json');
    },
    // 获取课程分类列表
    getCourseTypeList(params) {
        return request('post', '/sd_smi/api/v1/App_Course/getCourseTypeList', params, 'json');
    },
    // 获取课程列表
    getCourseList(params) {
        return request('post', '/sd_smi/api/v1/App_Course/getCourseList', params, 'json');
    },
    // 课程详情
    getCourseDetail(params) {
        return request('post', '/sd_smi/api/v1/App_Course/getCourseDetail', params, 'json');
    },
    // 收藏列表
    getCourseFavList(params) {
        return request('post', '/sd_smi/api/v1/App_Course/getCourseFavList', params, 'json');
    },
    // 收藏
    courseFav(params) {
        return request('post', '/sd_smi/api/v1/App_Course/courseFav', params, 'json');
    },

    // 学习记录
    getCourseHistoricalRecord(params) {
        return request('get', '/sd_smi/api/v1/App_Course/getCourseHistoricalRecord', params, 'json');
    },
    // 课程评价
    courseStar(params) {
        return request('post', '/sd_smi/api/v1/App_Course/courseStar', params, 'json');
    },
    // 我的课程列表
    getMyCourseList(params) {
        return request('get', '/sd_smi/api/v1/App_Course/getMyCourseList', params, 'json');
    },



    // 用户事件数据埋点
    userEventData(params) {
        return request('post', '/sd_smi/api/v1/App_User/addPoint', params, 'json', {useParams: true});
    },




    // 积分排行相关

    // 用户学习积分排名
    getCoursePointRanking(params) {
        return request('post', '/sd_smi/api/v1/App_Point/getCoursePointRanking', params, 'json', {useParams: true});
    },
    // 获取用户积分和排名
    getUserPointAndRanking(params) {
        return request('post', '/sd_smi/api/v1/App_Point/getUserPointAndRanking', params, 'json');
    },
    // 积分排名
    getPointRanking(params) {
        return request('post', '/sd_smi/api/v1/App_Point/getPointRanking', params, 'json', {useParams: true});
    },
    // 课程平均分排名
    getCourseRanking(params) {
        return request('post', '/sd_smi/api/v1/App_Point/getCourseRanking', params, 'json', {useParams: true});
    },
    // 讲师总分排名
    getTeacherRanking(params) {
        return request('post', '/sd_smi/api/v1/App_Point/getTeacherRanking', params, 'json', {useParams: true});
    },



    
    // 讲师申请界面选项列表
    getTeacherApplyItemList(params) {
        return request('get', '/sd_smi/api/v1/App_Course/getCourseTeacherApplyItemList', params, 'json');
    },
    // 讲师申请界面选项列表
    submitTeacherApply(params) {
        return request('post', '/sd_smi/api/v1/App_Course/submitCourseTeacherApply', params, 'json');
    },
}


// WEBPACK FOOTER //
// ./src/request/apis/school.js